import Image from "next/image";
import Tag from "./Tag";
import DescParagraph from "./DescParagraph";
import Title from "./Title"; 
import type { ContentStatus } from "@prisma/client";
import { getImageUrl } from "@/libs/CloudFlare";
import { displayDateTime } from "@/utils/displayDate";

interface IProps {
  text?: "black" | "white";
  contentByLangs: {
    id: string;
    title: string | null;
    desc: string | null;
    bannerImg: string | null;
    thumbnail: string | null;
    createAt: Date;
    updateAt: Date;
    status: ContentStatus;
    language: {
      id: string;
      name: string;
    };
    tags: {
      Tag: {
        name: string | null;
        id: string | null;
      };
    }[];
  }[];
  thumbnail: string | null;
  title: string | null;
  desc: string | null;
  href?: string;
}

function Card(props: IProps) { 
  return (
    <div className="flex flex-col items-start space-y-[12px] overflow-hidden w-full ">
      <div
        className="flex flex-row items-center justify-start space-x-2 w-full no-scrollbar"
      >
        {props.contentByLangs[0]?.tags?.map((tag) => (
          <Tag
            key={tag.Tag.id}
            title={tag.Tag.name ?? ""}
            href="#"
            text={props.text}
          />
        ))}
      </div>

      <a
        href={props.href ?? "/news/" + props.contentByLangs[0]?.id}
        className="!no-underline space-y-[12px] w-full"
      >
        {props?.contentByLangs[0]?.thumbnail ? (
          <Image
            alt="news"
            src={getImageUrl(props?.contentByLangs[0]?.thumbnail ?? "")}
            width={400}
            height={400}
            className=" w-full object-cover !aspect-square rounded-[28px]"
          />
        ) : props.thumbnail ? (
          <Image
            alt="news"
            src={getImageUrl(props?.thumbnail ?? "")}
            width={400}
            height={400}
            className=" w-full object-cover !aspect-square rounded-[28px]"
          />
        ) : (<div
          className=" w-full object-cover aspect-square bg-[#D9D9D9] rounded-[28px]"
        />)}

        <Title heading="h3" text={props.text}>
          {props.contentByLangs[0]?.title ?? ""}
        </Title>
        <div className="pt-[16px] md:pt-[28px]">
          <DescParagraph text={props.text}>
            {displayDateTime(
              new Date(props.contentByLangs[0]?.updateAt ?? ""),
              "MMM DD YYYY"
            )}
          </DescParagraph>
        </div>
      </a>
    </div>
  );
}

export default Card;

